import { render, staticRenderFns } from "./CustomAssets.vue?vue&type=template&id=97271262&"
import script from "./CustomAssets.vue?vue&type=script&lang=js&"
export * from "./CustomAssets.vue?vue&type=script&lang=js&"
import style0 from "./CustomAssets.vue?vue&type=style&index=0&id=97271262&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports